
  import {
    Component,
    Vue
  } from "vue-property-decorator";
  import PageFooter from '@/components/page-footer.vue';
  import { resetProviderPwd } from '@/api/user'
  import{
    removeUserInfo,
    removeUserId
  } from "@/utils/storage"

  @Component({
    name: 'account-safe',
    components: {
      PageFooter
    }
  })
  export default class AccountSafe extends Vue {
    private formData: any = {
      old_pwd: '',
      new_pwd: '',
      repeat_pwd: ''
    }
    private ruleForm: any = {
      'old_pwd': '请输入旧密码',
      'new_pwd': '请输入新密码',
      'repeat_pwd': '请输入再次输入新密码'
    }
    
    private isEmpty() {
      if(!this.formData.old_pwd){
        this.$message({
          type: 'warning',
          message: '请输入旧密码！'
        })
        return false
      }else if(!this.formData.new_pwd){
        this.$message({
          type: 'warning',
          message: '请输入新密码！'
        })
        return false
      }else if (this.formData.new_pwd !== this.formData.repeat_pwd) {
        this.$message({
          type: 'warning',
          message: '两次密码输入不一致，请重新输入！'
        })
        return false
      }
      return true
    }

    private async doSave() {
      // console.log(this.isEmpty(),11)
      if (!this.isEmpty()) return;
      try {
        await resetProviderPwd({
          PassWord: this.formData.old_pwd,
          NewPassWord: this.formData.new_pwd
        })
        this.$message({
          type: 'success',
          message: '修改成功！'
        })
        removeUserInfo()
        removeUserId()
        location.reload()
      } catch(e) {
        console.log(e)
      }
    }
  }
